import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '40px 20px',
    color: props => props.customStyles?.textColor || '#fff'
  },
  featureContainer: {
    marginBottom: '30px'
  },
  featureTitle: {
    fontSize: '24px',
    fontWeight: 700,
    marginBottom: '10px',
    color: 'inherit'
  },
  featureText: {
    fontSize: '16px',
    lineHeight: '1.6',
    color: 'inherit'
  }
}));

const formatFeatureText = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text.split('\\n').map((line, i) => (
    <React.Fragment key={i}>
      {line}
      <br />
    </React.Fragment>
  ));
};

export const CourseFeatures = ({ customContent, customStyles, position = 'left' }) => {
  const classes = useStyles({ customStyles });
  const features = customContent?.features || [];

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={6} key={index}>
            <div className={classes.featureContainer}>
              <Typography variant="h5" className={classes.featureTitle}>
                {feature.title || ''}
              </Typography>
              <Typography className={classes.featureText}>
                {formatFeatureText(feature.description || '')}
              </Typography>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}; 